<template>
  <div>
    <AdminUserTable></AdminUserTable>
  </div>
</template>


<script>
import AdminUserTable from "@/pages/admin/components/users/table/adminUserTable"
export default {
  components:{
    AdminUserTable,
  }
}
</script>